export default __webpack_public_path__ + "static/media/toque.142e793d.png";